<template>
  <div id="btn-voltar">
      <button type="button" class="btn btn-default btn-block"
              @click="voltar">
        <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
        Voltar
      </button>
  </div>
</template>
<script>
export default {

  name: "btn-voltar",

  methods:{
    voltar(){
      this.$router.go(-1)
    }
  }

}
</script>
<style lang="scss" scoped>
</style>
